export const METADATA_FIELDS_KEYS = [
  'Album',
  'Artist',
  'BPM',
  'Comment',
  'Composer',
  'Genre',
  'Grouping',
  'ISRC',
  'Lyrics',
  'ProNumber',
  'Release Date',
  'Title',
  'Year',
]

export const DISABLED_METADATA_FIELDS_KEYS = ['Title', 'TrackNumber']

export const MAX_METADATA_CSV_EXPORT_TRACK_COUNT = 250
